<script>
import { Bar, mixins } from "vue-chartjs";
import { getRandomColor } from "../../src/base";
import { fetchDataServive } from "../base";


export default {
  extends: Bar,
  mixins: [mixins.reactiveData],
  data() {
    return {
      chartData: "",
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  async created() {
    await fetchDataServive()
      .then((response) => {
        
        // console.log(response);
        function getNumber(str) {
          return str.replace(/[^0-9.]/g, "");
        }


        const color1 = getRandomColor();
        const color3 = getRandomColor();
    
        this.chartData = {
          labels: ["ping (ms)", "upload (Mbit/s)", "download (Mbit/s)"],
          datasets: [
            {
              label: `Microservice | ${response.status2.city}, ${response.status2.region}, ${response.status2.country}`,
              backgroundColor: color1,
              pointBackgroundColor: color1,
              borderWidth: 2,
              pointBorderColor: color1,
              data: [getNumber(response.status2.speedtest.speed), getNumber(response.status2.speedtest.upload), getNumber(response.status2.speedtest.download)],
            },
            {
              label: `Bot | ${response.status1.city}, ${response.status1.region}, ${response.status1.country}`,
              backgroundColor: color3,
              pointBackgroundColor: color3,
              borderWidth: 2,
              pointBorderColor: color3,
              data: [getNumber(response.status1.speedtest.speed), getNumber(response.status1.speedtest.upload), getNumber(response.status1.speedtest.download)],
            },
            
          ],
        };

        this.chartOptions = {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
                gridLines: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
              },
            ],
          },
          legend: {
            display: true,
          },
          responsive: true,
          maintainAspectRatio: false,
        };
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
};
</script>
